import { render } from "./EventsSidebar.vue?vue&type=template&id=09696e0f&ts=true"
import script from "./EventsSidebar.vue?vue&type=script&lang=ts"
export * from "./EventsSidebar.vue?vue&type=script&lang=ts"

import "./EventsSidebar.vue?vue&type=style&index=0&id=09696e0f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__